import { useServiceCenterPageData } from "@/views/service-center/hooks/useServiceCenterPageData";
import { useSearchParams } from "next/navigation";
import { ApiSearch } from "@/api/search";
import { useEffect, useMemo } from "react";
import { isServiceSearchValid } from "@/views/service-center/search/helpers";
import { useLocalizedQuery } from "@/hooks/locale/useLocalizeQuery/useLocalizeQuery";
import { useStore } from "@/hooks/system/useStore";

export const useServiceCenterSearchData = () => {
  const searchParams = useSearchParams();
  const { setSelectedInstructionFilters } = useStore("search");
  const q = searchParams.get("q");
  const pageNumber = searchParams.get("page_number") || 1;
  const categoryId = searchParams.get("category_id");

  useEffect(() => {
    setSelectedInstructionFilters({
      q,
      pageNumber: +pageNumber,
      categoryId: categoryId ? +categoryId : undefined,
    });
  }, [categoryId, pageNumber, q, searchParams, setSelectedInstructionFilters]);

  const isSearchValid = useMemo(() => isServiceSearchValid(q, +categoryId!), [q, categoryId]);

  const {
    serviceCenterPage: { serviceCenterPage, loading: serviceCenterPageLoading },
  } = useServiceCenterPageData();

  const { data: serviceCenterSearch, isLoading: serviceCenterSearchLoading } = useLocalizedQuery({
    queryKey: ["serviceCenterSearch", q, categoryId, +pageNumber!],
    queryFn: async lang =>
      ApiSearch.getServiceCenterSearch({
        q,
        pageNumber: +pageNumber,
        categoryId: categoryId ? +categoryId : undefined,
        lang,
      }),
    options: {
      enabled: isSearchValid,
    },
  });

  return {
    serviceCenterPage: {
      serviceCenterPage,
      loading: serviceCenterPageLoading,
    },

    serviceCenterSearch: {
      serviceCenterSearch,
      loading: serviceCenterSearchLoading,
    },
  };
};
